import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Icon } from './Icon';
import { User } from 'react-feather';
import { priceCategoryLabel } from '@pv/common/utils';

export const CapacityInfo = ({
  space,
  venue,
}: {
  space: {
    seated?: number;
    standing?: number;
  };
  venue: { minGroupSize?: number; priceCategory?: string };
}) => {
  return (
    <Stack spacing={4} direction="row">
      {!!venue.priceCategory && (
        <Stack spacing={2} direction="row">
          <Typography>{priceCategoryLabel(venue.priceCategory)}</Typography>
        </Stack>
      )}
      {!!space.seated && (
        <Stack spacing={2} direction="row">
          <Icon name="chair" />
          <Typography>{space.seated} Seated</Typography>
        </Stack>
      )}
      {!!space.standing && (
        <Stack spacing={2} direction="row">
          <User />
          <Typography>{space.standing} Standing</Typography>
        </Stack>
      )}
      {!!venue.minGroupSize && (
        <Typography>Minimum {venue.minGroupSize} Guests</Typography>
      )}
    </Stack>
  );
};
